export default "__VITE_ASSET__Ci$kZQyG__"